module.exports = __webpack_public_path__ + "img/chocolate.5bc1e640.png";